import { spawn } from 'redux-saga/effects';

import profileSagas from './profile/profileSagas';
import { sagas as makeSagas } from './makeModule';

export default function* sagas() {
	yield spawn(profileSagas);
	yield spawn(makeSagas);
}
